import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import { redirectToPath, goBack } from "utils/PathService";
import history from "utils/history";

const BackButton = () => {
  const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);
//   const returnTo = searchParams.get("returnTo");

  const showBackButton =  location?.state?.showBackButton || location?.state?.customBackPath

  const handleClick = () => {
    if (location?.state?.customBackPath) {
      redirectToPath(location.state.customBackPath);
    }
    else if (  location?.state?.showBackButton ||  history.length > 1) {
      goBack();
    }
  };


  if (!showBackButton) return null;
  return (
    <Button
      type="button"
      onClick={handleClick}
      size="sm"
    style={{ fontSize: "12px" , marginRight: "6px" }}
    >
        <i className="las la-arrow-left" 
         style={{ fontSize: "13px", marginRight: "6px" }}/>
         Back
    </Button>
  );
};

export default BackButton;
